import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { cn } from '@/lib/utils';

interface LockBadgeProps {
  className?: string;
}

// Small "members-only" lock indicator overlaid on a button's top-right corner.
// The hosting element must be position: relative.
const LockBadge = ({ className }: LockBadgeProps) => (
  <div
    className={cn(
      'absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-[#C89400] p-1 text-[10px]/none',
      className,
    )}
  >
    <FontAwesomeIcon icon={faLock} color="white" />
  </div>
);

export default LockBadge;
